module.exports = __webpack_public_path__ + "images/lang-info4ce807a21c10a85b0d3e8ea1268f8550.svg";